import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getUoms = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/uoms', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchUom = async (tagId, callback) => {
    try {
        const response = await risapi.get(`/api/uoms/${tagId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createUom = async (newUom, callback) => {
    try {
        const formData = convertJsonToFormData(newUom);
        const response = await risapi.post('/api/uoms', formData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const updateUom = async (editUom, callback) => {
    try {
        const formData = convertJsonToFormData(editUom);
        formData.append('_method', 'put');
        
        const response = await risapi.post(`/api/uoms/${editUom.id}`, formData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const destroyUom = async (deleteUom, callback) => {
    try {
        const response = await risapi.delete(`/api/uoms/${deleteUom.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ uom: deleteUom });
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }

};


export const destroyUomsMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/uoms/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({uom:ids});
        }
    } catch (error) {
        callback(error);
    }
}
